import { render, staticRenderFns } from "./SetDefault.vue?vue&type=template&id=0f8642c8"
import script from "./SetDefault.vue?vue&type=script&lang=js"
export * from "./SetDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports